import { render } from "./ListTextWithIconRenderer.vue?vue&type=template&id=861778bc"
import script from "./ListTextWithIconRenderer.vue?vue&type=script&lang=js"
export * from "./ListTextWithIconRenderer.vue?vue&type=script&lang=js"

import "./ListTextWithIconRenderer.vue?vue&type=style&index=0&id=861778bc&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__